/**
 * Où se tient un onglet dans sa rangée : la somme des largeurs des onglets qui le précèdent, et de leurs
 * espaces. Pur, testé à côté.
 *
 * La position ne se lit pas sur `onLayout` : au web, react-native-web ne le relance que quand la TAILLE d'un
 * nœud change. Un onglet qui glisse sans changer de largeur (un voisin qui part : la visio retirée au début
 * d'une présentation) gardait son ancienne position, et le trait restait entre deux onglets (Wajih, live en
 * prod du 03/11, « Tableau blanc »). Les largeurs, elles, se remesurent toujours.
 */
export function tabOffset<K extends string>(
    keys: readonly K[],
    widths: Partial<Record<K, number>>,
    gap: number,
    key: K
): { x: number; width: number } | null {
    let x = 0
    for (const each of keys) {
        const width = widths[each]
        if (width == null) return null
        if (each === key) return { x, width }
        x += width + gap
    }
    return null
}
